const routes = [
  {
    index: true,
    label: 'Aayush Dongol',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Projects',
    path: '/projects',
  },
  {
    label: 'Certifications',
    path: '/certifications',
  },
  {
    label: 'Blog',
    path: '/blog',
  },
  // {
  //   label: 'Stats',
  //   path: '/stats',
  // },
  {
    label: 'Contact',
    path: '/contact',
  },

];

export default routes;
